// 必要なVueファイルをimportする
//import Login from '@/views/admins/Login.vue';
//import PrescriptionsCreate from '@/views/admins/prescriptions/Create.vue';

// パスとVueファイルの定義
const AdminRoute = [
  // {
  //   path: '/admins/login',
  //   name: 'login',
  //   component: Login,
  // },
  // {
  //   path: '/admins/prescriptions/list',
  //   name: 'prescriptionsList',
  //   component: PrescriptionsList,
  //   meta: {requiresAuth: true, title: '処方箋一覧'}, // 認証が必要
  //   props: true,
  // },
];

export default AdminRoute;
